var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 22.4,
    height: 26.88,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8 187.203H144V21.606H28.8Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.039 138.137c-5.945-13.258-19.953-21.903-35.48-21.903-21.2.016-38.375 15.895-38.403 35.481 0 14.351 9.356 27.293 23.707 32.785 14.348 5.492 30.864 2.457 41.848-7.695 10.984-10.149 14.269-25.41 8.328-38.668zm-5.926 24.894c-4.949 11.043-16.613 18.246-29.554 18.246-17.66-.015-31.973-13.242-31.989-29.562 0-11.957 7.793-22.738 19.746-27.313 11.957-4.574 25.715-2.047 34.86 6.411 9.152 8.453 11.89 21.167 6.937 32.218z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.113 22.566a2.927 2.927 0 0 0-2.156-.96H31.937c-1.675 0-3.03 1.453-3.043 3.253l-.093 21.594c0 34.133 25.816 61.891 57.547 61.891 31.734 0 57.554-27.758 57.554-61.875L144 24.89a3.392 3.392 0 0 0-.887-2.325zm-5.293 23.887c0 30.528-23.09 55.356-51.472 55.356-28.38 0-51.465-24.828-51.465-55.34l.082-18.325h102.937Z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(22.4 0 0 26.88 0 0)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUCAYAAAA/MEEUAAAABHNCSVQICAgIfAhkiAAAAL5JREFUeJzt0MENwCAQwLDS/Xc+BkB5w8OeIMqamfk4/LcDXmVMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCZsCdAEpPILOpwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.13333 0 0 -.13333 0 26.88)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(168 0 0 -201.6 0 201.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUCAYAAAA/MEEUAAAABHNCSVQICAgIfAhkiAAAAL5JREFUeJzt0MENwCAQwLDS/Xc+BkB5w8OeIMqamfk4/LcDXmVMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCZsCdAEpPILOpwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.13333 0 0 -.13333 0 26.88)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(168 0 0 -201.6 0 201.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUCAYAAAA/MEEUAAAABHNCSVQICAgIfAhkiAAAANlJREFUeJzt2zEKw0AMAEE5YDDk/08NGFwkH8g6ncFkptQ1YlF7y8y858S+Ps+eb287Xl/nj4v3uA1hgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE5b58V/pX7mYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJnwAOJwFpf+Hv/oAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.13333 0 0 -.13333 0 26.88)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(168 0 0 -201.6 0 201.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUCAYAAAA/MEEUAAAABHNCSVQICAgIfAhkiAAAAMlJREFUeJzt0qENgFAUBMEHQeDpv1AUFEBWf8RMBZfNbTPzDB/76gF/JUwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGHCcZ/X6g2/5DFBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMeAEAGAK9FVZNegAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/profile2.72bc9c59f4d0141b6a528c684d39b775.svg";
export { ForwardRef as ReactComponent };